export const DOCUMENT_TYPES = {
  PASSPORT: "PASSPORT",
  PERMANENT_RESIDENT_CARD: "PERMANENT_RESIDENT_CARD",
  VISA: "VISA",
};
